import cx from 'classnames'
import { Add, Minus } from 'almanac-ui/icons'
import { Input } from 'almanac-ui/TextInputField/Input'
import { CountInputProps } from './Types'
import Styles from './CountInput.module.scss'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { pluralize } from 'utils'

const CountInput = ({
  value,
  unit,
  onChange: _onChange,
  min,
  max,
  size = 'lg',
  buttonVariant = 'secondary',
  flex,
  buttonSize = size,
  disabled = false,
  className,
  customPlusButton,
  applyRedesign = false,
  merged = false,
  ...rest
}: CountInputProps) => {
  const onChange = (val: number) => {
    if (min != null && val < min) return _onChange(min)
    if (max != null && val > max) return _onChange(max)
    return _onChange(val)
  }

  return (
    <div className={cx(Styles.wrapper, className, { [Styles.applyRedesign]: applyRedesign, [Styles.merged]: merged })}>
      <IconButton
        aria-label="Decrease"
        variant={buttonVariant}
        onPress={() => onChange(value - 1)}
        icon={Minus}
        isDisabled={disabled || (min !== undefined && value <= min)}
        size={buttonSize}
      />
      <Input
        size={size}
        className={cx(Styles.input, { [Styles.flex]: flex || merged, [Styles.greyedOut]: value === 0 })}
        value={unit ? `${value} ${pluralize(unit, value)}` : value}
        onChange={(e) => {
          const value = parseInt(e.target.value)
          if (isNaN(value)) return
          onChange(value)
        }}
        disabled={disabled}
        {...rest}
      />
      {customPlusButton || (
        <IconButton
          size={buttonSize}
          aria-label="Increase"
          variant={buttonVariant}
          onPress={() => onChange(value + 1)}
          icon={Add}
          isDisabled={disabled || (max !== undefined && value >= max)}
        />
      )}
    </div>
  )
}

export { CountInput }
